<template>
	<section>
		<div class="text-center w-75 m-auto">
			<h4 class="text-dark-50 text-center mt-0 font-weight-bold">Email enviado</h4>

			<p>Verifique seu email para ter mais instruções sobre a recuperação de sua senha.</p>

			<p><router-link to="Login" class="text-dark ml-1"><b>Voltar</b></router-link> para tela de login.</p> 
		</div>
	</section>
</template>

<script>
	export default {
		name: "email-enviado",
	}
</script>

<style>
</style>